import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

/**
 * Inline click-to-copy chip. Renders the value as plain text, but on hover/click
 * exposes a tiny copy button that flashes a checkmark and toasts confirmation.
 * Use for short ID-like values (case_id, acos_id) — not for free text.
 */
export default function CopyableField({ value, label, mono = false, testId }) {
    const [copied, setCopied] = useState(false);
    if (value === null || value === undefined || value === "") return <span className="text-muted-foreground">—</span>;
    const copy = async (e) => {
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(String(value));
            setCopied(true);
            toast.success(`Copied ${label || "value"}`);
            setTimeout(() => setCopied(false), 1200);
        } catch {
            toast.error("Copy failed");
        }
    };
    return (
        <button
            type="button"
            onClick={copy}
            data-testid={testId}
            className={`group inline-flex items-center gap-1 text-gray-800 hover:text-primary ${mono ? "font-mono text-xs" : ""}`}
            title={`Copy ${label || "value"}`}
        >
            <span>{value}</span>
            {copied
                ? <Check className="h-3 w-3 text-emerald-600" />
                : <Copy className="h-3 w-3 opacity-0 group-hover:opacity-70 transition-opacity" />}
        </button>
    );
}
